import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '@xo-union/tk-component-icons';
import styles from './rsvp-dropdown-select.scss';
import GuestStatus from './guest-status';

const RsvpSelect = ({ border, onClick, color, label, selected }) => {
  return (
    <div
      className={border ? styles.dropdownCellWithBorder : styles.dropdownCell}
      onClick={onClick}
      onKeyDown={e => (e.key === 'Enter' ? onClick() : null)}
      tabIndex={0}
      role="option"
      aria-selected={selected}
    >
      <GuestStatus
        className={classNames({
          [styles.notInvitedLabel]: label === 'Not Invited',
        })}
        color={color}
        label={label}
      />
      {selected && <Icon className={styles.check} name="checkmark" size="sm" />}
    </div>
  );
};

RsvpSelect.propTypes = {
  border: PropTypes.bool.isRequired,
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default RsvpSelect;
